// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Loader_backdrop__2H1xm"};